export default __webpack_public_path__ + "static/media/mindmap_06.2a5f46c5.png";